import { ApiClient } from './client'
import { POST_CONTENT_BOOKMARKS, DELETE_CONTENT_BOOKMARK } from './endpoints'

export const createContentBookmark = async (contentId: number) => {
  const body = {
    content_id: contentId,
  }
  const res = await ApiClient.post(POST_CONTENT_BOOKMARKS, body)
  return res
}

export const deleteContentBookmark = async (contentId: number) => {
  const res = await ApiClient.delete(DELETE_CONTENT_BOOKMARK(contentId))
  return res
}
